import t from "prop-types";
import e from "react";
import l from "classnames";
import { u as B } from "./ThemeProvider--i7ESlT5.es.js";
import { T as i } from "./index-Dd-4N6BE.es.js";
import { B as c } from "./Button-EJIc0kDA.es.js";
import { u as y } from "./utils-C0l876fA.es.js";
import { d as E } from "./deprecate-Dt6BL0Y6.es.js";
import './CruiseBody.css';const f = "CruiseBody-module__body___n1REi", N = "CruiseBody-module__compere___tGJY8", k = "CruiseBody-module__header___6Bl1Y", g = "CruiseBody-module__controls___rkDV0", h = "CruiseBody-module__singleStopControls___QiCfq", v = "CruiseBody-module__control___8ETha", b = "CruiseBody-module__counter___8ufKW", o = {
  body: f,
  compere: N,
  header: k,
  controls: g,
  singleStopControls: h,
  control: v,
  counter: b
}, m = ({
  currentStop: a,
  totalStops: r,
  onDoneClick: d,
  onNextClick: _,
  onBackClick: p,
  children: u,
  textDone: C
}) => {
  const n = B(), { t: s } = y();
  return /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement(
    "div",
    {
      className: l(
        o.body,
        n === "compere" && o.compere
      )
    },
    /* @__PURE__ */ e.createElement("div", null, /* @__PURE__ */ e.createElement("div", { className: o.header }, /* @__PURE__ */ e.createElement(i.Heading2, { tagName: "span", darkBg: !0, responsive: !0 }, u.title)), /* @__PURE__ */ e.createElement(i.Body, { tagName: "p", darkBg: !0, responsive: !0 }, u.body)),
    /* @__PURE__ */ e.createElement(
      "div",
      {
        className: l(
          o.controls,
          r === 1 && o.singleStopControls
        )
      },
      r > 1 && /* @__PURE__ */ e.createElement(
        "div",
        {
          className: l(
            o.control,
            o.counter
          )
        },
        /* @__PURE__ */ e.createElement(
          i.Body3,
          {
            darkBg: !0,
            theme: n,
            responsive: !0,
            tagName: "span"
          },
          `${a + 1}/${r}`
        )
      ),
      a > 0 && /* @__PURE__ */ e.createElement("div", { className: o.control }, /* @__PURE__ */ e.createElement(
        c.CancelButton,
        {
          handleClick: p,
          theme: n
        },
        s("Go back")
      )),
      r === 1 && /* @__PURE__ */ e.createElement("div", { className: o.control }, /* @__PURE__ */ e.createElement(
        c.ActionButton,
        {
          handleClick: d,
          theme: n
        },
        s("Got it")
      )),
      r > 1 && (a < r - 1 ? /* @__PURE__ */ e.createElement("div", { className: o.control }, /* @__PURE__ */ e.createElement(
        c.ActionButton,
        {
          buttonClassName: "cta-button",
          handleClick: _,
          theme: n
        },
        s("Next")
      )) : /* @__PURE__ */ e.createElement("div", { className: o.control }, /* @__PURE__ */ e.createElement(
        c.ActionButton,
        {
          handleClick: d,
          theme: n
        },
        C || s("Done")
      )))
    )
  ));
};
m.propTypes = {
  /** Index of the stop */
  currentStop: t.number.isRequired,
  /** Number of stops in the cruise */
  totalStops: t.number.isRequired,
  /** Called when cruise is finished */
  onDoneClick: t.func.isRequired,
  /** Called when next button is clicked */
  onNextClick: t.func.isRequired,
  /** Called when back button is clicked */
  onBackClick: t.func,
  /** Text labeling the button to end the cruise at the last stop */
  textDone: t.node,
  /**
   * An object with two keys: <br/>
   * \* *title* (node, required) - the title content for the cruise stop<br/>
   * \* *body* (node, required) - the body content for the cruise stop
   */
  children: t.shape({
    title: t.node.isRequired,
    body: t.node.isRequired
  }).isRequired
};
m.defaultProps = {
  textDone: null,
  onBackClick: () => !0
};
const Y = E("CruiseBody is deprecated")(m);
export {
  Y as D
};
